/* eslint-ignore */
// @ts-nocheck
import React, { useEffect, useState, useRef, useCallback } from 'react';

import { IoMdCheckmark, IoMdClose } from 'react-icons/io';
import { Container, Numerator, Selector, Label } from './styles';

function Stepper({
  activated = 0,
  scrollToEnd = false,
  handleClick = () => {},
  steppers = [
    'Seu documento',
    'Selecione seu telefone',
    'Ativação da conta',
    'Fim',
  ],
  errorState,
}) {
  const containerRef = useRef(null);
  const [brokeState, setBrokeState] = useState(false);
  const [prevActivatedState, setprevActivatedState] = useState(0);

  const scrollToNext = useCallback(() => {
    const el = document.getElementById(
      `stepperSelector${Math.round(activated - 1)}`
    );
    if (el && el.scrollIntoView) {
      el.scrollIntoView({ behavior: 'smooth', inline: 'center' });
      setprevActivatedState(activated);
    }
  });

  const scrollToPrev = useCallback(() => {
    const el = document.getElementById(
      `stepperSelector${Math.round(activated - 1)}`
    );
    if (el && el.scrollIntoView) {
      el.scrollIntoView({ behavior: 'smooth', inline: 'center' });
      setprevActivatedState(activated);
    }
  });

  useEffect(() => {
    if (Number(activated) === activated && activated % 1 !== 0)
      setBrokeState(true);
    else setBrokeState(false);
  }, [activated]);

  useEffect(() => {
    if (activated !== 1 || prevActivatedState !== 0) {
      if (Math.floor(activated) > prevActivatedState) {
        scrollToNext();
      }
      if (Math.floor(activated) < prevActivatedState) {
        scrollToPrev();
      }
    }
  }, [activated]);

  useEffect(() => {
    if (scrollToEnd) {
      const el = document.getElementById('stepperContainer');
      if (el) {
        el.scrollTo({ top: 0, left: el.scrollWidth, behavior: 'smooth' });
      }
    }
  }, [scrollToEnd]);

  return (
    <Container id="stepperContainer" ref={containerRef}>
      <div style={{ minWidth: '80vw' }} />
      {steppers.map((value, index) => (
        <Selector
          key={index}
          onClick={() => handleClick()}
          id={`stepperSelector${index}`}
        >
          <Numerator
            isActivated={activated === index + 1}
            isAccept={Math.round(activated) > index + 1}
            brokeState={brokeState}
            errorState={errorState === index + 1}
          >
            {errorState === index + 1 ? (
              <IoMdClose />
            ) : index + 1 < Math.round(activated) ? (
              <IoMdCheckmark />
            ) : (
              index + 1
            )}
          </Numerator>

          <Label
            isActivated={activated === index + 1}
            isAccept={activated > index + 1}
          >
            {value}
          </Label>
        </Selector>
      ))}
      <div style={{ minWidth: '80vw' }} />
    </Container>
  );
}

export default Stepper;
